<template>
  <div class="mx-auto">
    <v-card>
      <v-container>
        <v-card-text>
          <base-form-generator :schema="schema" v-model="form" />
          <span class="label--text">Unggah Berkas SAP</span>
          <template v-if="typeof form['file_sap'] === 'string'">
            <div>
              <v-btn color="orange" dark small @click="onView"><v-icon left>mdi-eye</v-icon>Lihat Berkas</v-btn>
              <v-btn class="mx-md-2" color="primary" dark small @click="onUbahBerkas">
                <v-icon left>mdi-pencil</v-icon>Ubah Berkas
              </v-btn>
            </div>
          </template>
          <template v-else>
            <validation-provider mode="passive" name="File Sap" :rules="{ required: true }" v-slot="{ errors }">
              <v-file-input
                v-model="form['file_sap']"
                :accept="['.pdf']"
                outlined
                prepend-icon=""
                append-icon="mdi-paperclip"
                persistent-hint
                :hint="`Jenis file unggahan PDF Maksimal 4 MB`"
                :rules="[
                  (value) =>
                    !value ||
                    (value && value.size < roundDecimal(max * 1000)) ||
                    'Berkas yang Anda upload melebihi kapasitas maksimum!',
                ]"
                :placeholder="`Unggah berkas sap`"
                :error-messages="errors"
              />
            </validation-provider>
          </template>
        </v-card-text>

        <v-card-text>
          <div class="my-2">
            <v-alert color="blue" text>
              <v-checkbox v-model="konfirmasi">
                <template v-slot:label>
                  <div>Saya menyatakan bahwa laporan SAP di atas adalah benar</div>
                </template>
              </v-checkbox>
            </v-alert>
          </div>
        </v-card-text>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import BaseFormGenerator from '../../../../components/base/BaseFormGenerator';
import { ValidationProvider } from 'vee-validate';
import { roundDecimal } from '../../../../utils/format';

export default {
  components: { BaseFormGenerator, ValidationProvider },
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      form: {},
      konfirmasi: null,
      max: 4096,
    };
  },

  computed: {
    schema() {
      return [
        {
          type: 'VTextField',
          name: 'judul',
          label: 'Nama Pelatihan',
          labelColor: 'secondary',
          hint: 'Nama Pelatihan maksimal 50 karakter',
          placeholder: 'Tuliskan nama pelatihan',
          required: true,
          grid: { cols: 12 },
          counter: 50,
          outlined: true,
          singleLine: true,
        },
        {
          type: 'VSelect',
          name: 'k_topik_sap_psp',
          label: 'Nama Mata Diklat',
          labelColor: 'secondary',
          hint: 'Pilih Topik',
          placeholder: 'Pilih Topik',
          items: this.$mapForMaster(this.masters.topik_sap_psp),
          required: true,
          grid: { cols: 12 },
          outlined: true,
          singleLine: true,
        },
        {
          type: 'VTextarea',
          name: 'tujuan',
          label: 'Tujuan Pelatihan',
          labelColor: 'secondary',
          hint: '',
          placeholder: 'Tuliskan deskripsi tujuan pelatihan tersebut',
          required: true,
          grid: { cols: 12 },
          outlined: true,
          singleLine: true,
        },
        {
          type: 'VTextarea',
          name: 'indikator',
          label: 'Indikator Pelatihan',
          labelColor: 'secondary',
          hint: '',
          placeholder: 'Tuliskan deskripsi indikator pelatihan tersebut',
          required: true,
          grid: { cols: 12 },
          outlined: true,
          singleLine: true,
        },
        {
          type: 'VTextarea',
          name: 'pendahuluan',
          label: 'A. Pendahuluan',
          labelColor: 'secondary',
          hint: 'Isian deskripsi singkat minimal 50 karakter & maksimal 125 karakter',
          placeholder: 'Tuliskan deskripsi pendahuluan pelatihan tersebut',
          required: true,
          grid: { cols: 12 },
          counter: 125,
          rules: { required: true, minChar: 50 },
          outlined: true,
          singleLine: true,
        },
        {
          type: 'VTextarea',
          name: 'kegiatan',
          label: 'B. Kegiatan Inti',
          labelColor: 'secondary',
          hint: 'Isian deskripsi singkat minimal 100 karakter & maksimal 250 karakter',
          placeholder: 'Tuliskan deskripsi kegiatan pelatihan tersebut',
          required: true,
          grid: { cols: 12 },
          counter: 250,
          rules: { required: true, minChar: 100 },
          outlined: true,
          singleLine: true,
        },
        {
          type: 'VTextarea',
          name: 'penutup',
          label: 'C. Penutup',
          labelColor: 'secondary',
          hint: 'Isian deskripsi singkat minimal 50 karakter & maksimal 125 karakter',
          placeholder: 'Tuliskan deskripsi penutup pelatihan tersebut',
          required: true,
          grid: { cols: 12 },
          counter: 125,
          rules: { required: true, minChar: 50 },
          outlined: true,
          singleLine: true,
        },
      ];
    },
  },

  methods: {
    getValue() {
      return { form: this.form };
    },

    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'konfirmasi', null);
    },

    initForm(value) {
      const formulir = [...(this.schema || []), { name: 'file_sap' }];
      for (const item of formulir) {
        if (item.name) {
          this.$set(this.form, item.name, this.$getDeepObj(value, item.name) || null);
        }
      }
    },

    validate() {
      let status = true;

      if (!this.$getDeepObj(this, 'form.file_sap')) {
        this.$error('Harap isikan file berkas SAP');
        status = false;
      } else if (!this.konfirmasi) {
        this.$error('Harap konfirmasi isian SAP terlebih dahulu');
        status = false;
      }

      return status;
    },

    onUbahBerkas() {
      this.$set(this.form, 'file_sap', null);
    },

    onView() {
      if (!this.$getDeepObj(this, 'initValue.url_sap')) return;
      window.open(this.$getDeepObj(this, 'initValue.url_sap'), '_blank');
    },

    roundDecimal(value) {
      return roundDecimal(value);
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
